import { OrmModel, AttrField, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.VISIBILITY)
export default class Visibility extends BaseModel {
  @StringField()
  public id: string

  @AttrField([])
  public visibility: Record<string, boolean>
}
